import { createGlobalStyle } from 'styled-components';

export const InfoTooltipGlobalStyles = createGlobalStyle`
  .tooltip-overlay {
    padding-top: 0px;

    .ant-tooltip-inner {
      float: right;
      width: fit-content;
      min-width: 150px;
      max-height: 500px;
      padding: 16px;
      overflow-y: auto;
    }
  }
`;
